const divFromEquipService = {
  noServices: 'Sin servicio añadido',
  noFound: 'No se encontró ningún servicio',
  onDemand: 'Servicio bajo demanda',
  remaining: (date, days) => days === 1 ? `Fecha de caducidad: ${date} (${days} día restante)` : `Fecha de caducidad: ${date} (${days} días restante)`,
  inDelay: (date, days) => days === 1 ? `Fecha de caducidad: ${date} (${days} día retrasado)` : `Fecha de caducidad: ${date} (${days} días retrasado)`,
  lastDay: 'El servicio caducará pronto, último día de validez',
  mandatory: 'Obligatorio',
  haveOpenedActions: (actions) => actions === 1 ? `(El servicio tiene ${actions} acción abierta o vencida)` : `(El servicio tiene ${actions} acciones abiertas o vencidas)`,
  scheduledTo: 'Programado para:',
  scheduledDate: 'Fecha programada:',
  inactive: 'DESACTIVADO',
  loadMore: 'Mostrar más',
};

export default divFromEquipService;
